import React from "react";
import "../upload.css";

function Uploading({ name, fileLoaded }) {
  return (
    <div>
      <li className="row">
        <i className="fas fa-file-alt"></i>
        <div className="content">
          <div className="details">
            <span className="name">{name} • Uploading</span>
            {/*name*/}
            <span className="percent">{fileLoaded}%</span>
            {/*fileLoaded*/}
          </div>
          <div className="progress-bar">
            <div className="progress" style={{ width: "50px" }}></div>
            {/*fileLoaded */}
          </div>
        </div>
      </li>
    </div>
  );
}

export default Uploading;
